<nav class="navbar navbar-dark bg-primary sticky sticky-top navbar-main px-sm-0 animated fadeIn navbar-expand-sm">
  <div class="container px-0 px-sm-3">
    <h1 class="m-0"><a href="/" class="navbar-brand d-block">FOOTBALLER<span class="footballer-brand-z">Z</span></a></h1>

    <div class="nav-item mr-auto d-flex d-sm-inline-flex flex-sm-row">
      <a href="javascript:" routerLink="/event-list" class="btn btn-primary text-left" [title]="'events.matches' | translate" [routerLinkActive]="['active']" (click)="closeMobileMenu()">
        <span class="sr-only">{{ 'events.matches' | translate }}</span>
        <i [class]="('navigation.matches' | nogoshIcon) + ' d-inline-block'" aria-hidden="true"></i>
      </a>
      <a href="javascript:"  routerLink="/chat-list" class="btn btn-primary text-left notification-nav-link" [title]="'chat.title' | translate" [routerLinkActive]="['active']" (click)="closeMobileMenu()">
        <i [class]="('navigation.chat' | nogoshIcon) + ' d-inline-block'" aria-hidden="true"></i>
        <span class="sr-only">{{ 'chat.title' | translate }}</span><!-- 💬 -->
        @if (chatUnreadCount > 0) {
          <span class="notification-nav-badge">{{ chatUnreadCount > 9 ? '9+' : chatUnreadCount }}</span>
        }
      </a>
      <a href="javascript:" routerLink="/notifications" class="btn btn-primary text-left notification-nav-link" [title]="'notifications.centerTitle' | translate" [routerLinkActive]="['active']" (click)="closeMobileMenu()">
        <i [class]="('navigation.notifications' | nogoshIcon) + ' d-inline-block'" aria-hidden="true"></i>
        <span class="sr-only">{{ 'notifications.centerTitle' | translate }}</span>
        @if ((notificationCount$ | async) > 0) {
          <span class="notification-nav-badge">{{ (notificationCount$ | async) > 9 ? '9+' : (notificationCount$ | async) }}</span>
        }
      </a>
      <a href="javascript:" routerLink="/playspace/false" class="btn btn-primary text-left" [title]="'locations.title' | translate" [routerLinkActive]="['active']" (click)="closeMobileMenu()">
        <i [class]="('locations.location' | nogoshIcon) + ' d-inline-block'" aria-hidden="true"></i>
        <span class="sr-only">{{ 'locations.title' | translate }}</span>
      </a>
      <a href="javascript:" routerLink="/player-detail/false" class="btn btn-primary text-left" [title]="'navigation.profile' | translate" [routerLinkActive]="['active']" (click)="closeMobileMenu()">
        <i [class]="('player.profile' | nogoshIcon) + ' d-inline-block'" aria-hidden="true"></i>
        <span class="sr-only">{{ 'navigation.profile' | translate }}</span>
      </a>
      @if (false) {
        <a href="javascript:"  routerLink="/help" class="btn btn-primary text-left" [title]="'navigation.about' | translate" [routerLinkActive]="['active']">
          <i [class]="('common.question' | nogoshIcon) + ' d-none d-sm-inline-block'"></i><!-- ❓ -->
          <span class="d-sm-none">{{ 'navigation.about' | translate }}</span>
        </a>
      }
    </div>
    @if (auth.isAuthenticated$ | async) {
      <a href="javascript:" class="btn dropdown-toggle no-caret float-right d-sm-none text-white font-weight-300 mr-n2" [title]="'common.more' | translate" data-toggle="collapse" data-target="#navbarNavMain" aria-controls="navbarNavMain" aria-expanded="false" [attr.aria-label]="'accessibility.toggleNavigation' | translate">
        <i [class]="('navigation.more' | nogoshIcon) + ' d-expanded-true-none'" aria-hidden="true"><span class="sr-only">{{ 'common.more' | translate }}</span></i>
        <span class="h2 font-weight-300 line-height-3 align-middle d-expanded-false-none">&times;<span class="sr-only">{{ 'common.more' | translate }}</span></span>
      </a>
    }

    @if (auth.isAuthenticated$ | async) {
      <div class="collapse navbar-collapse mx-n3 px-2" id="navbarNavMain">
        <ul class="navbar-nav flex-fill mx-n1 mx-sm-0">
          <!--  DROPDOWN MOBILE VERSION  -->
          <li class="nav-item d-flex flex-column d-sm-none">
            <div class="nav-divider opacity-10"></div>
            @if (false) {
              <a href="javascript:" class="btn btn-primary text-left" routerLink="/feedback" [routerLinkActive]="['active']" (click)="closeMobileMenu()">{{ 'navigation.feedback' | translate }}</a>
            }
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mangonel.nogosh&hl=en&gl=US" class="btn btn-primary text-left" (click)="closeMobileMenu()">{{ 'navigation.androidApp' | translate }}</a>
            <a target="_blank" href="https://apps.apple.com/us/app/footballer-zone/id1312823941" class="btn btn-primary text-left" (click)="closeMobileMenu()">{{ 'navigation.iosApp' | translate }}</a>
            <div class="nav-divider opacity-10"></div>
            @if (auth.isAuthenticated$ | async) {
              <a href="javascript:" class="btn btn-primary text-left" (click)="closeMobileMenu(); logout()"><i [class]="'auth.logout' | nogoshIcon" aria-hidden="true"></i> {{ 'auth.logout' | translate }}</a>
            }
          </li>
          <!--  DROPDOWN >= TABLET VERSION  -->
          <li class="ml-sm-auto nav-item dropdown d-none d-sm-inline-block" dropdown>
            <a href="javascript:" dropdownToggle class="btn text-white dropdown-toggle no-caret" [title]="'common.more' | translate"><i [class]="'navigation.more' | nogoshIcon" aria-hidden="true"><span class="sr-only">{{ 'common.more' | translate }}</span></i><!-- <span class="caret"></span> --></a>
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right mt-2 border-top-0" role="menu">
              @if (false) {
                <a href="javascript:" class="dropdown-item" routerLink="/feedback" [routerLinkActive]="['active']">{{ 'navigation.feedback' | translate }}</a>
              }
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mangonel.nogosh&hl=en&gl=US" class="dropdown-item">{{ 'navigation.androidApp' | translate }}</a>
              <a target="_blank" href="https://apps.apple.com/us/app/footballer-zone/id1312823941" class="dropdown-item">{{ 'navigation.iosApp' | translate }}</a>
              <div class="dropdown-divider"></div>
              @if (auth.isAuthenticated$ | async) {
                <a href="javascript:" class="dropdown-item logout-link" (click)="logout()"><i [class]="'auth.logout' | nogoshIcon" aria-hidden="true"></i> {{ 'auth.logout' | translate }}</a>
              }
            </div>
          </li>
        </ul>
      </div>
    }



  </div>
</nav>
